import { success, failure, request } from 'app/actions';
import * as actions from './reportApplicationDetailsActions';

const initialRanking = {
  content: [],
  totalrecords: 0,
  totalpages: 0,
  recordsperpage: 10,
  page: 0,
};

const initialState = {
  evaluation: {},
  gradeByGroup: {},
  gradeByStudent: [],
  gradeByDiscipline: [],
  gradeByAbility: [],
  gradeReportStudent: {},
  gradeDetailStudent: {},
  filterReports: [],
  filtersLevelApplication: [],
  filtersQuestionsApplication: [],
  filtersComponents: [],
  detailEvaluationAlternatives: [],
  questions: [],
  questionDetail: {},
  questionsComponent: [],
  ranking: initialRanking,
  alternativeReport: [],
  cicleStudent: [],
  studentQuestions: [],
  studentsAnswersQuestionReport: [],
  gradeByGroupFailureCode: null,
  essaySSOUrl: null,
  loadingEssaySSO: false,
  essaySSOUrlFetched: false,
  gradeComparativeByStudent: [],
  hasComparative: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case request(actions.GET_STUDENTS_ANSWERS_QUESTION_REPORT):
      return {
        ...state,
        studentsAnswersQuestionReport: initialState.studentsAnswersQuestionReport,
      };
    case success(actions.GET_STUDENTS_ANSWERS_QUESTION_REPORT):
      return { ...state, studentsAnswersQuestionReport: action.payload.content };
    case request(actions.GET_ESGRADE_REPORT_STUDENT):
      return {
        ...state,
        gradeReportStudent: initialState.gradeReportStudent,
      };
    case success(actions.GET_ESGRADE_REPORT_STUDENT):
      return {
        ...state,
        gradeReportStudent: action.payload.content,
      };
    case request(actions.GET_ESGRADE_DETAIL_BY_STUDENT):
      return {
        ...state,
        gradeDetailStudent: initialState.gradeReportStudent,
      };
    case success(actions.GET_ESGRADE_DETAIL_BY_STUDENT):
      return {
        ...state,
        gradeDetailStudent: action.payload.content,
      };
    case success(actions.GET_EVALUATION):
      return { ...state, evaluation: action.payload.content };
    case actions.RESET_ASSESSMENT_PANEL:
      return {
        ...state,
        gradeByGroup: initialState.gradeByGroup,
        gradeByGroupFailureCode: initialState.gradeByGroupFailureCode,
        ranking: initialState.ranking,
        studentsAnswersQuestionReport: initialState.studentsAnswersQuestionReport,
        detailEvaluationAlternatives: initialState.detailEvaluationAlternatives,
      };
    case failure(actions.GET_ESGRADE_BY_GROUP):
      return {
        ...state,
        gradeByGroup: initialState.gradeByGroup,
        gradeByGroupFailureCode: action.payload.errCode,
      };
    case success(actions.GET_ESGRADE_BY_GROUP):
      return {
        ...state,
        gradeByGroup: action.payload.content,
        gradeByGroupFailureCode: initialState.gradeByGroupFailureCode,
      };
    case failure(actions.GET_ESGRADE_BY_STUDENT):
      return {
        ...state,
        gradeByStudent: initialState.gradeByStudent,
      };
    case success(actions.GET_ESGRADE_BY_STUDENT):
      return {
        ...state,
        gradeByStudent: action.payload.content,
      };
    case failure(actions.GET_FILTERS_LEVEL_APPLICATION_REPORT):
      return {
        ...state,
        filtersLevelApplication: initialState.filtersLevelApplication,
      };
    case success(actions.GET_FILTERS_LEVEL_APPLICATION_REPORT):
      return {
        ...state,
        filtersLevelApplication: action.payload.content,
      };
    case request(actions.GET_DETAIL_EVALUATION_ALTERNATIVES):
      return {
        ...state,
        detailEvaluationAlternatives: initialState.detailEvaluationAlternatives,
      };
    case success(actions.GET_DETAIL_EVALUATION_ALTERNATIVES):
      return {
        ...state,
        detailEvaluationAlternatives: action.payload.content,
      };
    case failure(actions.GET_ESGRADE_QUESTIONS_DETAIL):
      return {
        ...state,
        questions: initialState.questions,
      };
    case success(actions.GET_ESGRADE_QUESTIONS_DETAIL):
      return {
        ...state,
        questions: action.payload.content,
      };
    case failure(actions.GET_ES_QUESTION_DETAIL):
      return {
        ...state,
        questionDetail: initialState.questionDetail,
      };
    case success(actions.GET_ES_QUESTION_DETAIL):
      return {
        ...state,
        questionDetail: action.payload.content,
      };
    case failure(actions.GET_FILTERS_QUESTIONS_APPLICATION_REPORT):
      return {
        ...state,
        filtersQuestionsApplication: initialState.filtersQuestionsApplication,
      };
    case success(actions.GET_FILTERS_QUESTIONS_APPLICATION_REPORT):
      return {
        ...state,
        filtersQuestionsApplication: action.payload.content,
      };
    case failure(actions.GET_FILTERS_REPORTS):
      return {
        ...state,
        filterReports: initialState.filterReports,
      };
    case success(actions.GET_FILTERS_REPORTS):
      return {
        ...state,
        filterReports: action.payload.content,
      };
    case failure(actions.GET_ES_FILTERS_COMPONENTS):
      return {
        ...state,
        filtersComponents: initialState.filtersComponents,
      };
    case success(actions.GET_ES_FILTERS_COMPONENTS):
      return {
        ...state,
        filtersComponents: action.payload.content,
      };
    case success(actions.GET_ESGRADE_BY_RANKING_STUDENT): {
      const prevContent = state.ranking.content || [];
      const newContent = action.payload.content || [];
      const shouldAppend =
        prevContent.length > 0 &&
        newContent.length > 0 &&
        newContent[0].position > prevContent[prevContent.length - 1].position;

      if (!shouldAppend) {
        return {
          ...state,
          ranking: action.payload,
        };
      }
      return {
        ...state,
        ranking: {
          ...action.payload,
          content: [...prevContent, ...newContent],
        },
      };
    }
    case failure(actions.GET_ESGRADE_BY_DISCIPLINE):
      return {
        ...state,
        gradeByDiscipline: initialState.gradeByDiscipline,
      };
    case success(actions.GET_ESGRADE_BY_DISCIPLINE):
      return {
        ...state,
        gradeByDiscipline: action.payload.content,
      };
    case failure(actions.GET_ES_QUESTIONS_DETAILS_BY_COMPONENTS):
      return {
        ...state,
        questionsComponent: initialState.questionsComponent,
      };
    case success(actions.GET_ES_QUESTIONS_DETAILS_BY_COMPONENTS):
      return {
        ...state,
        questionsComponent: action.payload.content,
      };
    case failure(actions.GET_ESGRADE_BY_ABILITY):
      return {
        ...state,
        gradeByAbility: initialState.gradeByAbility,
      };
    case success(actions.GET_ESGRADE_BY_ABILITY):
      return {
        ...state,
        gradeByAbility: action.payload.content,
      };
    case failure(actions.GET_ESGRADE_DETAIL_ALTERNATIVE_REPORT):
      return {
        ...state,
        alternativeReport: initialState.alternativeReport,
      };
    case success(actions.GET_ESGRADE_DETAIL_ALTERNATIVE_REPORT):
      return {
        ...state,
        alternativeReport: action.payload.content,
      };
    case failure(actions.GET_ES_EVALUATIONS_CICLE_STUDENT):
      return {
        ...state,
        cicleStudent: initialState.cicleStudent,
      };
    case success(actions.GET_ES_EVALUATIONS_CICLE_STUDENT):
      return {
        ...state,
        cicleStudent: action.payload.content.question,
      };
    case failure(actions.GET_ESGRADE_STUDENT_QUESTIONS):
      return {
        ...state,
        studentQuestions: initialState.studentQuestions,
      };
    case success(actions.GET_ESGRADE_STUDENT_QUESTIONS):
      return {
        ...state,
        studentQuestions: action.payload.content.questions,
      };
    case request(actions.GET_ESSAY_SSO_URL):
      return {
        ...state,
        essaySSOUrl: initialState.essaySSOUrl,
        loadingEssaySSO: true,
      };
    case success(actions.GET_ESSAY_SSO_URL):
      return {
        ...state,
        essaySSOUrl: action.payload.content,
        loadingEssaySSO: false,
        essaySSOUrlFetched: true,
      };
    case failure(actions.GET_ESSAY_SSO_URL):
      return {
        ...state,
        essaySSOUrl: initialState.essaySSOUrl,
        loadingEssaySSO: false,
        essaySSOUrlFetched: true,
      };
    case request(actions.GET_ESGRADE_COMPARATIVE_BY_STUDENT):
      return {
        ...state,
        gradeComparativeByStudent: initialState.gradeComparativeByStudent,
        hasComparative: false,
      };
    case failure(actions.GET_ESGRADE_COMPARATIVE_BY_STUDENT):
      return {
        ...state,
        gradeComparativeByStudent: initialState.gradeComparativeByStudent,
        hasComparative: false,
      };
    case success(actions.GET_ESGRADE_COMPARATIVE_BY_STUDENT):
      return {
        ...state,
        gradeComparativeByStudent: action.payload.content,
        hasComparative: true,
      };
    default:
      return state;
  }
};

export default reducer;
